// composables/useLayout.ts
import { ref, computed, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'

// Default loads synchronously because it is used most often
import DefaultLayout from '@/layout/DefaultLayout.vue'

export type LayoutName = 'DefaultLayout' | 'MinimalLayout'

const manualLayout = ref<LayoutName | null>(null)

// Lazy-import the others
const layouts: Record<LayoutName, any> = {
  DefaultLayout,
  MinimalLayout: defineAsyncComponent(() => import('@/layout/MinimalLayout.vue'))
}

export function useLayout() {
  const route = useRoute()

  const layout = computed<LayoutName>(() => {
    return manualLayout.value || (route.meta.layout as LayoutName) || 'DefaultLayout'
  })

  function setLayout(name: LayoutName | null) {
    manualLayout.value = name
  }

  const layoutComponent = computed(() => layouts[layout.value] || DefaultLayout)

  return {
    layout,
    layoutComponent,
    setLayout
  }
}
